"use strict";

window._theme = window._theme || {};

_theme.PageBrands = (function(){
    function init(){
        const brandsList = $('[data-brands-list]');
        const brand = brandsList.find('.brand');
        $('.brands-page .brands-list .brands-hide a').each(function(){
            let $this = $(this);
            let str = $(this).attr('href').split('?q=')[1];
            let v = decodeURI(str);
            let strreg = '';
            let brandlink = '';
            if(v.indexOf('%') == -1){
                brandlink = v.replace(/\s+/g, "-").replace(/\./g, "-").replace(/[^a-zA-Z0-9- ]/g, "").replace(/---/g, "-").replace(/--/g, "-").toLowerCase();
                if(brandlink[brandlink.length-1] == '-'){brandlink = brandlink.slice(0,brandlink.lastIndexOf('-'))}
            }
            else{
                strreg = v.substr(v.indexOf('%'),3);
                brandlink = v.replace(strreg,'-').replace(/\s+/g, "-").replace(/[^a-zA-Z0-9- ]/g, "").replace(/---/g, "-").replace(/--/g, "-").toLowerCase();
                if(brandlink[brandlink.length-1] == '-'){brandlink = brandlink.slice(0,brandlink.lastIndexOf('-'))}
            } 
            $this.closest('.brand-item').find('.brands_link').attr('href',`/collections/${brandlink}`);
            $(this).parent('.brands-hide').remove();
        });

        brand.each(function() {
            var self = $(this),
                brandTitle = self.find('.azbrands-title div').text().trim(),
                character = self.find("ul.brand-grid li:eq(0) a").text().charAt(0).toLowerCase(),
                alphabet = brandsList.prev(),
                alphabetChild = alphabet.children();
      
            alphabetChild.each(function() {
              var aElm = $(this).find('a');
              
              if(aElm.text().trim().toLowerCase() == brandTitle) {
                if(!aElm.hasClass('readonly')) 
                  aElm.addClass('readonly');
                return; 
              }; 
            });
            if(!self.find('.azbrands-title').length) {
              //console.log(character)
              self.find('.brand-grid').children().appendTo('.brand-' + character + " ul.brand-grid");
              self.remove();
            }      
        });

      var vendorItem = brandsList.prev().find('.vendor-letter a.readonly');
      vendorItem.on('click', function() {
        var selfText = $(this).text().trim().toLowerCase();  
        brand.hide().filter(function(e){
          var title =  $(this).find('.azbrands-title div').text().trim().toLowerCase();  
          if(title == selfText) {
            $(this).show();          
            return;
          };        
        });
        
        $('.azbrandstable .all-brand a').click(function(){
          brand.show();
        });
      });
      
      var allVendor = brandsList.prev().find('a.readonly');
      allVendor.on('click', function() {
        brandsList.prev().find('a').removeClass('active').attr("aria-selected","false");
        var self = $(this);
        if(!self.hasClass('active')) {
            self.addClass('active').attr("aria-selected","true");
        };
        var offsetTop = brandsList.prev('.azbrandstable').offset().top;
        $('body,html').animate({
          scrollTop: offsetTop
        }, 600);
      });
      
      var brandList = brandsList.prev().find('a.readonly');
      brandList.each(function(i, e) {
        if (e.hasAttribute("disabled")) {
            e.removeAttribute("disabled");
        }
      });
      
      var filterUrl = new URL(window.location.href)
      var maxHref = filterUrl.searchParams.get('sparameter');
      $('ul.azbrandstable li a').each(function(){
       var t = $(this).text().toLowerCase().trim();
        if(t == maxHref ){
            $(this).trigger('click');
        }
      });
    }

    return { init: init }
})();

$(function(){
    _theme.PageBrands.init();
});